const Navbar = () => {
	return (
		<nav>
			<a href="/"><img src="./img/logo.png" className="img-logo" alt=""></img></a>
			{/* <!-- <div className="logo no-select"><a href="index.html">Saqib</a></div> --> */}
			<ul>
				<li><a href="/projects">Projects</a></li>
				<li><a href="/skills">Skills</a></li>
				<li><a href="/work-experience">Work Experience</a></li>
				<li><a href="/contact">Contact</a></li>
			</ul>
			<img src="./img/menu.png" className="menu" alt=""></img>
			<img src="./img/close.png" className="close" alt=""></img>
		</nav>
	)
}

export default Navbar;